import React from "react";
import { FooterComponent } from "../StyledComponents/footerComponents";

const Footer = () => {
  return (
    <FooterComponent>
      <p>MKS Sistemas © Todos os direitos reservados</p>
    </FooterComponent>
  );
};

export default Footer;
